import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export const creditScoreMap: Record<CreditScore, MapItem> = {
  below_580: { label: 'Under 580' },
  between_580_and_619: { label: '580 - 619' },
  between_620_and_679: { label: '620 - 679' },
  between_680_and_719: { label: '680 - 719' },
  above_720: { label: '720+' },
}

export const creditScoreSchema = z.enum(Object.keys(creditScoreMap) as [CreditScore, ...CreditScore[]])

export type CreditScore =
  | 'below_580'
  | 'between_580_and_619'
  | 'between_620_and_679'
  | 'between_680_and_719'
  | 'above_720'
